import { Stack, TextField, Typography } from "@mui/material";
import React, { memo } from "react";
import { Controller } from "react-hook-form";

const CustomInput = ({
  control,
  name,
  label,
  rules = {},
  stackProps = {},
  labelPosition = "",
  paramsFunc = () => ({}),
  slotProps: callerSlotProps = {},
  ...others
}) => {
  // Default slotProps — callers can extend/override each slot independently
  const mergedSlotProps = {
    ...callerSlotProps,
    htmlInput: {
      style: { fontSize: "12px" },           // default font size
      ...callerSlotProps.htmlInput,           // caller overrides win
    },
    input: {
      ...callerSlotProps.input,              // endAdornment, startAdornment, etc.
    },
  };

  return (
    <Stack
      {...stackProps}
      flexDirection={labelPosition === "left" ? "row" : "column"}
      spacing={0.5}
      className="custom-input-container field-container"
    >
      {(labelPosition === "top" || labelPosition === "left") && (
        <Typography className="label" variant="subtitle2">
          {label || ""}
        </Typography>
      )}

      <Controller
        control={control}
        name={name}
        rules={rules}
        render={({ field: { ref, ...field }, fieldState: { error } }) => (
          <TextField
            {...field}
            inputRef={ref}
            size="small"
            value={field?.value || ""}
            label={labelPosition ? "" : label || ""}
            margin="dense"
            fullWidth
            variant="outlined"
            error={Boolean(error)}
            helperText={error?.message || ""}
            {...others}
            slotProps={mergedSlotProps}
            {...paramsFunc({ field })}
          />
        )}
      />
    </Stack>
  );
};

export default memo(CustomInput);
